import React, { useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// components
import TeamMemberCard from "../TeamMemberCard";
import BioModal from "../BioModal";

// data
import { memberDetails } from "../MemberDetails";

// styles
import * as styles from "./IndianLeadershipTeamNew.module.css";

const teamDetails = [
  {
    id: "maluk-mohamed",
    drName: "Maluk Mohamed",
    designation: "Co-Founder/VP Research/Head(India)",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/maluk_v2.png"
        alt="Maluk Mohamed"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "senthil-kumaran",
    drName: "Senthil Kumaran",
    designation: "Head, India Finance",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/senthil_v1.png"
        alt="Senthil Kumaran"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "sana-khan",
    drName: "Sana Khan",
    designation: "Director, Growth",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/sana@2x.png"
        alt="Sana Khan"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "ashfaaq-m",
    drName: "Ashfaaq M",
    designation: "Associate Director, Growth & Marketing",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/ashfaq_v1.png"
        alt="Ashfaaq M"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "shashank-joshi",
    drName: "Shashank R Joshi",
    designation: "Consultant Endocrine and Metabolic Physician",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/shashank_v2.png"
        alt="Shashank R Joshi"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "srinivasa-murthy",
    drName: "Dr Srinivasa Murthy",
    designation: "Director, Clinical Research",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/srinivasa-murthy.png"
        alt="Srinivasa Murthy"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "suresh-damodharan",
    drName: "Dr. Suresh Damodharan",
    designation: "Director, Clinical",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/suresh-new.png"
        alt="Suresh Damodharan"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "ayesha-tabbassum-r",
    drName: "Ayesha Tabbassum R",
    designation: "Associate Director, Coach Operations",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/ayesha_v2.png"
        alt="Ayesha Tabbassum R"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "ravi-sankar",
    drName: "Dr. Ravi Sankar",
    designation: "Director, Medical",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/dr_ravi.png"
        alt="Ravi Sankar"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "asan-abdul",
    drName: "Asan Abdul",
    designation: "Associate Director, Customer success",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/asan-abdul-new.png"
        alt="Asan Abdul"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "praveena-suresh",
    drName: "Praveena Suresh",
    designation: "Associate Director, Learning & Development",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/praveena-new.png"
        alt="Praveena Suresh"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "jane-ganesh",
    drName: "Jane Ganesh",
    designation: "Associate Director - Human Resources",
    company: "",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/jane_v1.png"
        alt="Jane Ganesh"
        placeholder="blurred"
        quality={100}
      />
    ),
  },
  {
    id: "sharath-reddy",
    drName: "Sharath Reddy",
    designation: "Engineering Director",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/sharath-new.png"
        alt="Founder"
        placeholder="blurred"
        quality={100}
      />
    ),
    content1:
      "Sharath joined Twin as Engineering Director in Feb 2021 , he leads the Engineering team at Twin India. Prior to joining Twin, Sharath led product development at Amazon , Target Retail , and Motorola Solutions.",
    content2:
      "Sharath graduated from JNTU Hyderabad  with a Master's in Computer Science Engineering",
  },
  {
    id: "dr-rohit-warrier",
    drName: "Dr. Rohit Warrier",
    designation: "Head of Clinical Operations, Twinhealth",
    drImage: (
      <StaticImage
        src="../../../images/aboutUs/dr-rohit.png"
        alt="Dr Rohit Warrier"
        placeholder="blurred"
        quality={100}
      />
    ),
    content1:
      "Dr. Rohit Warrier is a physician-scientist specializing in Endocrinology, Diabetes, and Regenerative Medicine, with a rare ability to integrate engineering principles into clinical practice. He is deeply committed to the science of diabetes remission and metabolic reversal, believing that precision, behaviour-driven interventions can produce lasting biological change.",
    content2:
      "He holds certifications from the European Board of Endocrinology, Diabetes & Metabolism, the American Board of Regenerative Medicine, and the Royal College of Physicians, Edinburgh, and serves as Communications Director for the American Diabetes Association's Immunology & Transplantation Special Interest Group. His mission is to bridge clinical practice, research, and digital innovation to transform metabolic care globally.",
  },
];

const IndianLeadershipTeamNew = ({
  title = "Indian Leadership Team",
  members = teamDetails,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const handleReadBio = member => {
    // Find full member details from memberDetails
    const fullMemberData = memberDetails.find(m => m.id === member.id);

    if (fullMemberData) {
      setSelectedMember(fullMemberData);
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedMember(null);
  };

  return (
    <>
      <section className={styles.indianLeadershipSection}>
        <div
          className={`container scroll_animate ${inView && "inview"}`}
          ref={ref}
        >
          {/* Heading */}
          <div className="row">
            <div className="col-12">
              <h2 className={styles.sectionTitle}>{title}</h2>
            </div>
          </div>

          {/* Team Members Grid */}
          <div className={`row ${styles.teamGrid}`}>
            {members.map((member, index) => (
              <div key={index} className="col-6 col-md-6 col-lg-4">
                <TeamMemberCard member={member} onReadBio={handleReadBio} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bio Modal */}
      <BioModal
        show={showModal}
        onHide={handleCloseModal}
        member={selectedMember}
      />
    </>
  );
};

IndianLeadershipTeamNew.propTypes = {
  title: PropTypes.string,
  members: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      drName: PropTypes.string.isRequired,
      designation: PropTypes.string.isRequired,
      company: PropTypes.string,
      drImage: PropTypes.node.isRequired,
    })
  ),
};

export default IndianLeadershipTeamNew;
